export default __webpack_public_path__ + "static/media/WhatsApp Community_AlAin.5a457614.png";